import { ANGENOMMENE_KANTE_PX, slotThatFits, type PhotoSlot } from './imageFit'

/**
 * Ein Foto im Buch.
 *
 * Anders als das Vorschaubild im Tagebuch lädt dieses nichts nach: die
 * Bilddaten sind vorher gesammelt worden (siehe usePrintAssets.ts) und liegen
 * als fertige Adresse vor. Ein Bild, das erst während des Druckens geladen
 * wird, fehlt auf dem Papier - deshalb bekommt diese Komponente die URL und
 * nicht die Aufgabe, sie zu besorgen.
 *
 * loading steht ausdrücklich auf eager. Die Vorgabe lazy lädt erst, wenn das
 * Bild in die Nähe des sichtbaren Bereichs kommt; im Druck ist das der Grund,
 * warum die hinteren Seiten leer bleiben.
 */
export function PrintPhoto({
  url,
  slot,
  alt,
}: {
  url: string | undefined
  slot: PhotoSlot
  alt: string
}) {
  // Der Platz wird kleiner, wenn die Pixel ihn nicht tragen. Die echten
  // Pixelmasse kennt PhotoMeta nicht, gerechnet wird deshalb mit der kleineren
  // der beiden Grössen, die im Bestand vorkommen - siehe imageFit.ts.
  const echter = slotThatFits(slot, ANGENOMMENE_KANTE_PX)
  if (!url || !echter) return null

  return (
    <figure className={`dr-foto dr-foto--${echter}`}>
      <img src={url} alt={alt} loading="eager" decoding="sync" />
    </figure>
  )
}
